export default __webpack_public_path__ + "static/media/sf7.e193237f.jpeg";